import { render } from "./HospitalInfoM.vue?vue&type=template&id=3ec86fd0"
import script from "./HospitalInfoM.vue?vue&type=script&lang=js"
export * from "./HospitalInfoM.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__